export const matchSequence = {
  // home, away ,work
  playoff: {
    32: [
      [1, 32, 1],
      [16, 17, 1],
      [9, 24, 1],
      [8, 25, 1],

      [5, 28, 1],
      [12, 21, 1],
      [13, 20, 1],
      [4, 29, 1],

      [3, 30, 1],
      [14, 19, 1],
      [11, 22, 1],
      [6, 27, 1],

      [7, 26, 1],
      [10, 23, 1],
      [15, 18, 1],
      [2, 31, 1],
    ],
    16: [
      [1, 16, 1],
      [8, 9, 1],

      [5, 12, 1],
      [4, 13, 1],

      [3, 14, 1],
      [6, 11, 1],

      [7, 10, 1],
      [2, 15, 1],
    ],
    8: [
      [1, 8, 1],
      [4, 5, 1],
      [3, 6, 1],
      [2, 7, 1]
    ],
    4: [
      [1, 4, 1],
      [2, 3, 1],
    ],
    2: [
      [1, 2, 1],
      [3, 4, 1, true],
    ]
  },
  normal: {
    3: [
      [1, 3, 2],
      [2, 3, 1],
      [1, 2, 3],
    ],
    4: [
      [1, 4, 3],
      [2, 3, 1],
      [1, 3, 2],
      [2, 4, 1],
      [1, 2, 4],
      [3, 4, 2]
    ],
    5: [
      [1, 5, 3],
      [2, 4, 1],
      [3, 5, 2],
      [4, 1, 3],
      [5, 2, 4],
      [1, 3, 5],
      [2, 4, 3],
      [3, 1, 4],
      [4, 2, 5],
      [5, 3, 1]
    ],
    6: [
      [1, 6, 3],
      [2, 5, 4],
      [3, 6, 2],
      [4, 5, 1],
      [1, 3, 6],
      [2, 4, 5],
      [3, 1, 4],
      [5, 2, 6],
      [6, 3, 2],
      [4, 1, 5],
      [5, 3, 6],
      [2, 4, 1],
      [1, 5, 3],
      [3, 4, 2],
      [6, 1, 4]
    ]
  },
  odd: {
    round1: {
      3: [
        [1, 3, 2],
        [2, 3, 1],
        [1, 2, 3],
      ],
      4: [
        [1, 4, { split: 2 }],
        [2, 3, { split: 1 }],
        [{ loserOf: 1 }, { loserOf: 2 }, { splitWinners: 'losers' }],
        [{ winnerOf: 1 }, { winnerOf: 2 }, { splitLosers: 'winners' }],
      ]
    },
    round2: {
      3: [
        [1, 3, 2],
        [2, 3, 1],
        [1, 2, 3],
      ],
      4: [
        [1, 4, { split: 2 }],
        [2, 3, { split: 1 }],
        [{ loserOf: 1 }, { loserOf: 2 }, { splitWinners: 'losers' }],
        [{ winnerOf: 1 }, { winnerOf: 2 }, { splitLosers: 'winners' }],
      ]
    },
  }
}
